import React from 'react';
import { EVENT_TYPES } from '@/shared/constants/event-types.v4';

interface CalendarDayProps {
    date: Date;
    isSelected: boolean;
    onSelect: (date: Date) => void;
    status: {
        color?: string;
        fontWeight?: string | number;
        opacity?: number;
        markers?: Array<{ type: string; status: string }>;
    };
}

export const CalendarDay: React.FC<CalendarDayProps> = React.memo(({ date, isSelected, onSelect, status }) => {
    const isToday = date.toDateString() === new Date().toDateString();
    const displayColor = isToday && !isSelected ? '#2ecc71' : status.color;
    const displayWeight = isToday ? '900' : (status.fontWeight as any);

    return (
        <td style={{ padding: '2px' }}>
            <button 
                type="button" onClick={() => onSelect(date)} 
                style={{ 
                    width: '36px', height: '36px', 
                    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', 
                    cursor: 'pointer', backgroundColor: 'transparent', 
                    borderRadius: '8px', border: isSelected ? '2px solid #f29b11' : 'none',
                    position: 'relative', color: displayColor, fontWeight: displayWeight, opacity: status.opacity || 1
                }}
            >
                <span style={{ fontSize: '14px' }}>{date.getDate()}</span>
                {status.markers && status.markers.length > 0 && (
                    <div style={{ display: 'flex', gap: '2px', marginTop: '1px', justifyContent: 'center' }}>
                        {status.markers.slice(0, 3).map((m, i) => {
                            const isRec = m.type === EVENT_TYPES.RECOVERY || m.type === 'SLEEP';
                            let dotColor = '#444';
                            if (m.status === 'SKIPPED') dotColor = '#ef4444';
                            else if (m.status === 'COMPLETED' || m.status === 'ACTIVE') dotColor = isRec ? '#00f2ff' : '#2ecc71';
                            else if (m.status === 'PLANNED') dotColor = isRec ? '#3b82f6' : '#f29b11';
                            return <div key={i} style={{ width: '2px', height: '2px', borderRadius: '50%', backgroundColor: dotColor }} />;
                        })}
                    </div>
                )}
            </button>
        </td>
    );
});
